import React, { useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup } from '@saviynt/design-system';

import IntegrationsSideCard from '../../components/IntegrationsSideCard/IntegrationsSideCard';
import ButterflyGraph1 from '../../features/Butterfly1-POC/ButterflyGraph1';
import { type NodeData } from '../../features/Butterfly2-POC/Butterfly2Data';
import ButterflyGraph2 from '../../features/Butterfly2-POC/ButterflyGraph2';
import NetworkGraph from '../../features/NetworkGraph/NetworkGraph';

import './GraphsPage.css';

/**
 * Page for displaying POC on graphs
 */
function GraphsPage() {
  const [categorySelection, setCategorySelection] = useState(3);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [selectedNode, setSelectedNode] = useState<NodeData | null>(null);

  return (
    <Box className='GraphsPage'>
      <ToggleButtonGroup
        selection={categorySelection}
        setSelection={setCategorySelection}
        dataTestId='category-toggle-buttons'>
        <ToggleButton label='Peacock Graph' dataTestId='toggle-peacock' />
        <ToggleButton label='Butterfly 1' dataTestId='toggle-butterfly1' />
        <ToggleButton label='Butterfly 2' dataTestId='toggle-butterfly2' />
      </ToggleButtonGroup>

      {categorySelection === 1 && <NetworkGraph />}
      {categorySelection === 2 && <ButterflyGraph1 />}
      {categorySelection === 3 && (
        <ButterflyGraph2
          openSidePanel={(node) => {
            setSelectedNode(node);
            setIsSidePanelOpen(true);
          }}
        />
      )}

      <IntegrationsSideCard
        isOpen={isSidePanelOpen}
        onClose={() => setIsSidePanelOpen(false)}
        selectedNode={selectedNode}
      />
    </Box>
  );
}

export default GraphsPage;
